import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "pa-preview-content",
    templateUrl: "./preview-content.component.html",
    styleUrls: ["./preview-content.component.scss"],
    standalone: false
})
export class PreviewContentComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PreviewContentComponent>
  ) {}

  ngOnInit() {
    document.getElementById("container").innerHTML = this.data.html;
  }

  onClose() {
    this.dialogRef.close();
  }
}
